<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 5.83398H17.5" stroke="#737278" stroke-width="1.25" stroke-linecap="round" />
    <path d="M5 10H15" stroke="#737278" stroke-width="1.25" stroke-linecap="round" />
    <path d="M8.33337 14.166H11.6667" stroke="#737278" stroke-width="1.25" stroke-linecap="round" />
  </svg>
</template>
